import { Button, Divider, Icon, Text } from '@chakra-ui/react';
import {
  ExternalIngestionFolderFragment,
  ExternalValidationReportDataFragment,
  IngestionFolderValidationErrorReviewFragment,
} from '@client/graphql/__generated__/types';
import { TriangleAlertIcon } from 'lucide-react';
import { FC } from 'react';
import { ComplianceValidationVariant } from '../ComplianceDrawer';
import { IssueFormData } from '../components/AddIssueModal';
import { FolderIssuesCard } from '../FolderIssuesCard';
import { FolderValidation } from '../utils/folderIssues.utils';

interface DocumentsSidebarHeaderProps {
  variant: ComplianceValidationVariant;
  loading: boolean;
  folder: ExternalIngestionFolderFragment;
  validationData: ExternalValidationReportDataFragment | null;
  userAddedFolderIssues?: IngestionFolderValidationErrorReviewFragment[];
  hiddenFolderIssues?: IngestionFolderValidationErrorReviewFragment[];
  hideViewAllIssues?: boolean;
  onViewAllIssues: () => void;
  onAddFolderIssue?: (issueData: IssueFormData) => void | Promise<void>;
  onDeleteFolderIssue?: (reviewId: string) => void | Promise<void>;
  onHideFolderIssue?: (
    isHidden: boolean,
    message?: string,
    documentCategory?: string,
    documentForm?: string,
    documentName?: string,
    ruleUuid?: string
  ) => void | Promise<void>;
}

export const DocumentsSidebarHeader: FC<DocumentsSidebarHeaderProps> = ({
  variant,
  loading,
  folder,
  validationData,
  userAddedFolderIssues,
  hiddenFolderIssues,
  hideViewAllIssues = false,
  onViewAllIssues,
  onAddFolderIssue,
  onDeleteFolderIssue,
  onHideFolderIssue,
}) => {
  const folderValidation = validationData?.folderValidation as unknown as
    | FolderValidation
    | undefined;

  const folderErrorCount = folder.validationErrorCount || 0;

  return (
    <>
      {!hideViewAllIssues && (
        <Button
          _hover={{ bg: 'compliance.button.secondary.hover' }}
          bg="transparent"
          borderColor="compliance.sidebar.border"
          borderWidth={1}
          color="compliance.button.secondary.text"
          leftIcon={
            folderErrorCount > 0 ? (
              <Icon
                as={TriangleAlertIcon}
                color="compliance.icon.error"
                size={16}
              />
            ) : undefined
          }
          size="sm"
          onClick={onViewAllIssues}
        >
          {folderErrorCount > 0 ? `View all issues` : 'View all checks'}
        </Button>
      )}

      <FolderIssuesCard
        folderValidation={folderValidation}
        hiddenIssues={hiddenFolderIssues}
        userAddedIssues={userAddedFolderIssues}
        variant={variant}
        onAddFolderIssue={onAddFolderIssue}
        onDeleteFolderIssue={onDeleteFolderIssue}
        onHideFolderIssue={onHideFolderIssue}
      />
      <Divider opacity={1} />
      {loading && <Text>Loading documents...</Text>}
    </>
  );
};
